import ServiceTwoIcon from "./ServiceTwoIcon";

export default function TirePositionPicker({
  options,
  selectedCategories,
  onToggle,
  onSetAction,
  onOpen,
}) {
  const selected = options.filter((item) => selectedCategories[item.id]);
  const commonAction =
    selected.length &&
    selected.every((item) => selectedCategories[item.id] === "R")
      ? "R"
      : "L";
  return (
    <div className="tire-picker">
      <div className="tire-picker__intro">
        <ServiceTwoIcon name="info" />
        <p>
          روی جای هر چرخ بزنید؛ می‌توانید چند لاستیک را هم‌زمان انتخاب کنید.
        </p>
      </div>
      <div className="tire-picker__stage">
        <span className="tire-picker__front">
          جلوی خودرو
          <ServiceTwoIcon name="arrow" />
        </span>
        <div className="tire-picker__car">
          <span className="tire-picker__windshield" />
          <ServiceTwoIcon name="car" />
          <span className="tire-picker__cabin" />
        </div>
        {options.map((item) => {
          const position = item.key;
          const action = selectedCategories[item.id];
          return (
            <button
              key={item.id}
              type="button"
              className={`tire-picker__wheel tire-picker__wheel--${position}${action ? " is-selected" : ""}`}
              aria-pressed={Boolean(action)}
              onClick={() => onToggle(item)}
            >
              <span>
                <ServiceTwoIcon name={action ? "check" : "tire"} />
              </span>
              <b>{position.includes("front") ? "جلو" : "عقب"}</b>
              <small>{position.includes("right") ? "راست" : "چپ"}</small>
            </button>
          );
        })}
      </div>
      {selected.length > 0 && (
        <div className="tire-picker__selection">
          <div>
            <b>{selected.length.toLocaleString("fa-IR")} چرخ انتخاب شد</b>
            <small>نوع عملیات برای همهٔ چرخ‌های انتخاب‌شده</small>
          </div>
          <div className="tire-picker__actions">
            <button
              type="button"
              className={commonAction === "L" ? "is-active" : ""}
              onClick={() => onSetAction("L")}
            >
              <ServiceTwoIcon name="replace" />
              تعویض
            </button>
            <button
              type="button"
              className={commonAction === "R" ? "is-active" : ""}
              onClick={() => onSetAction("R")}
            >
              <ServiceTwoIcon name="eye" />
              بازدید
            </button>
          </div>
          <div className="tire-picker__chips">
            {selected.map((item) => (
              <button type="button" key={item.id} onClick={() => onOpen(item)}>
                {item.title}
                <ServiceTwoIcon name="edit" />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
